// src/utils/ids/is-valid-install-id/is-valid-install-id.ts
var validInstallId = /^(?:.{11}|.{22})$/;
function isValidInstallId(maybeId) {
  return validInstallId.test(maybeId);
}

export {
  isValidInstallId
};
